import { Logo } from 'common/components';
import { Outlet } from 'react-router-dom';

function Header() {
  return (
    <>
      <header>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 col-sm-3 col-xs-12">
              <Logo to="" size={'small'} />
            </div>

            <div className="col-md-9 col-sm-9 col-xs-12"></div>

            <div className="col-md-12 col-sm-12 col-xs-12">
              <h2 className="registration-heading">Avanse Payment Portal</h2>
            </div>
          </div>
        </div>
      </header>
      <Outlet />
    </>
  );
}

export default Header;
